export const mtsAnaliticScript = `
(function (dl, id) {
    window[dl] = window[dl] || [];
    const script = document.createElement('script'),
          params = dl !== 'dataLayer' ? '?l=' + dl : '';
    script.async = true;
    script.src = \`https://tag.a.mts.ru/container/\${id}/tag.js\${params}\`;
    document.head.appendChild(script);
  })('dataLayer', '01973b2b-e30c-7e99-b533-3508353d65ed');
`
